<template>
  <section class="page-container">
    <h1>{{ title }}</h1>
    <!--    <div class="btn-top-container">-->
    <!--      <v-button-->
    <!--        type="plain"-->
    <!--        @click="newTicketDialog = true">New Support Ticket</v-button>-->
    <!--    </div>-->

    <div
      class="filter-top">
      <div class="form-item">
        <v-input
          v-model="search"
          :prefixIcon="'el-icon-search'"
          placeholder="Ticket, Customer Name, Customer Contact, CS Name"
          @keyEnter="searchData" />
      </div>
    </div>
    <div
      class="filter-container">
      <div class="filter-left">
        <div class="filter-box">
          <div class="filter-box-text">
            <span>Created</span>
          </div>
          <div class="flex">
            <v-date-picker
              v-model="refer_date"
              :clearable="true"
              type="daterange"
              @change="searchData" />
          </div>
        </div>
      </div>
      <div
        class="filter-middler filter-box status-button">
        <div class="filter-box-text">
          <span>Status</span>
          <span>
            <span
              class="all"
              @click="handlerSelectAll('status')">All</span>
            <span
              class="all"
              @click="handlerNoneAll('status')">None</span>
          </span>
        </div>
        <div class="flex">
          <v-checkbox-group
            v-model="status"
            :borderBlock="true"
            :isColumn="false"
            :list="statusTypeOptions"
            @change="searchData" />
        </div>
      </div>
      <div class="filter-last">
        <div class="filter-box-text">
          <span>Type & Stage</span>
          <span class="flex">
            <span
              class="all"
              @click="handlerSelectAll('stts')">All</span>
            <span
              class="all"
              @click="handlerNoneAll('stts')">None</span>
          </span>
        </div>
        <div class="flex">
          <div>
            <div
              class="flex-checkout">
              <v-checkbox-group
                v-model="stts"
                :type="2"
                :list="sttsList"
                @change="filterData" >
                <template #default="{ item }">
                  <span class="flex">
                    <span
                      class="circle"
                      :class="{
                        'yellow-dark':[1].includes(item.id),
                        'blue': [2].includes(item.id),
                      }"></span>
                    <span>{{ item['name'] }}</span>
                  </span>
                </template>
              </v-checkbox-group>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="transparent">
      <list-table
        :tableData="tableData"
        is-sme
        @rowClick="rowClick"
      ></list-table>
    </div>

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />


  </section>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import ListTable from '@/views/tickets/components/list-table.vue'
import {
  getSMETicketList,
} from '@/api/new_sme'
import MixinOptions from '@/mixins/options'
import {setTicketClientUpdated} from '@api/ticket'

export default {
  name: 'TicketsList',
  components: {
    ListTable
  },
  mixins: [MixinOptions],
  data() {
    return {
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      search: '',
      refer_date: [],
      status: [1,2],
      tableData: [],
      stts:[],
      isFirst:false,
      statusList: [],
      defaultFilter:{
        refer_date: [],
        status: [1,2],
        stts:[],
      }
    }
  },
  computed: {
    ...mapState('filter', ['selectFilterData']),
    title() {
      return 'SME Tickets'
    },
    sttsList(){
      return this.globalOptions.sme_ticket_type || []
    },
  },
  watch: {
    property: {
      immediate: true,
      handler(val, old) {
        this.$nextTick(() => {
          this.tableData = []
          this.pageConfig.currentPage = 1
          this.type = 0
          this.refer_date = []
          let {smeTicket={}} =  this.selectFilterData||{}
          Object.keys(smeTicket).forEach(item=>{
            this[item] = smeTicket[item]
          })
          this.setFilterData(smeTicket||{})
          this.handler().handlerGetData()
        })
      }
    }
  },
  methods: {
    ...mapActions('filter', ['setFilterData']),
    handlerSelectAll(target) {
      let origin = ''
      switch(target) {
        case 'status':
          origin = 'statusTypeOptions'
          break
        case 'stts':
          origin = 'sttsList'
          break
      }
      const data = this[origin].reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      this[target] = data
      this.filterData()
    },

    handlerNoneAll(target){
      this[target] = []
      this.filterData()
    },
    rowClick(row) {
      if(row.client_updated === 1) {
        this.network().setTicketClientUpdated(row.id)
      }
      let params = {
        status:this.status,
        assignee_id:this.assignee_id,
        refer_date:this.refer_date,
        stts:this.stts,
        type:this.type,
        pageConfig:this.pageConfig,
        search: this.search,
      }
      this.setFilterData({smeTicket:params})

      this.$router.push({
        path: '/sme/tickets/detail',
        query: {
          ticket_id: row.id
        }
      })
    },
    searchData() {
      if(this.isFirst)
      {
        return this.isFirst =false
      }
      this.pageConfig.currentPage = 1
      this.handler().handlerGetData()
    },
    filterData() {
      this.pageConfig.currentPage = 1
      this.handler().handlerGetData()
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.handler().handlerGetData()
    },
    selectAssignee(id) {
      this.network().setTicketCs(id)
    },
    handler() {
      return {
        handlerGetData: () => {
          this.network().getSMETicketList()
        }
      }
    },
    network() {
      return {
        setTicketClientUpdated: async (id, index) => {
          const { data } = await setTicketClientUpdated({
            ticket_id: id
          })
        },
        getSMETicketList: async () => {
          const { data } = await getSMETicketList({
            type: this.type,
            stts: this.stts,
            assignee_id: this.assignee_id,
            is_snooze: this.is_snooze,
            status: this.status,
            page: this.pageConfig.currentPage,
            search: this.search,
            refer_date: this.refer_date,
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
        },
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  position: relative;
  color: #303133;
  h1{
    font-family: inter;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
    letter-spacing: 0.3px;
    color: #24292E;
    margin-bottom: 15px;
  }
  .hide-selection {
    width: 100%;
    /deep/ tr {
      td:first-child, th:first-child {
        display: none;
      }
    }

  }

  .blue-circle {
    position: relative;
    display: inline-block;
    margin-right: 5px;
    width: 8px;
    height: 8px;
    border-radius: 100%;
    cursor: pointer;
    position: absolute;
    left: -5px;
    &.blue{
      background: #409EFF;
    }
    &.yellow-circle{
      background: #DBAB09!important;
    }
    &::after {
      content: '';
      position: absolute;
      top: -5px;
      left: -5px;
      right: -5px;
      bottom: -5px;
    }
  }
  .btn-top-container {
    position: absolute;
    top: 10px;
    right: 0;
  }
  .text-right {
    display: flex;
    justify-content: flex-end;
    .el-input {
      margin-left: 10px;
      width: 250px;
    }
    .el-button{
      height: 32px;
      margin-left: 0;
      margin-right: 15px;
    }
    .button-blue{
      font-family: Inter;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.15px;
      color: #0366D6;
    }
    .filter-select{
      margin-left: 0;
      margin-right: 15px;
    }
  }
  .filter-top{
    margin-bottom: 14px;
  }
  .filter-flex {
    margin-top: 10px;
    .form-item:first-child {
      margin-right: 15px;
      width: 400px;
    }
    .form-item:last-child {
      width: 400px;
    }
  }
  .filter-select {
    margin-left: 10px;
    width: 175px;
  }

  .transparent {
    margin-top: 15px;
  }
  .dialog-container {
    .dialog-header {
      position: relative;
      padding: 15px 15px 5px 15px;
      border-bottom: 1px solid #dddfe7;
      .abs-top-right {
        top: 15px;
        right: 15px;
      }
    }
    .dialog-body {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 15px 0;
      span {
        display: block;
        margin-bottom: 10px;
        cursor: pointer;
      }
    }
  }
  .filter-bar{
    border: 1px solid #D1D5DA;
    height: 46px;
    padding: 11px 16px;
    background: #FFFFFF;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    white-space: nowrap;
    .icon{
      font-weight: 900;
      font-size: 14px;
      color: #586069;
    }
    .main-left{
      display: flex;
      overflow: hidden;
    }
    .left{
      margin-right: 15px;
      .icon-filter{
        margin-right: 11px;
      }
      .text{
        font-weight: 600;
        font-size: 14px;
      }
    }
    .filter-status{
      .status-item{
        height: 24px;
        padding: 4px 8px;
        background: #F1F8FF;
        border-radius: 100px;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        color: #0366D6;
        .content{
          font-weight: 600;
        }
        & + .status-item{
          margin-left: 18px;
        }
      }
    }
    .right{
      display: flex;
      align-items: center;
      position: relative;
      padding-left: 16px;
      .translucence{
        position: absolute;
        right: 100%;
        width: 15px;
        height: 44px;
        background: linear-gradient(90deg, rgba(219, 237, 255, 0) 0%, #DBEDFF 100%);
      }
      .right-cotent{
        background: #DBEDFF;
      }
      .icon-rotate{
        margin-right: 18px;
        color: #0366D6;
      }
    }
    &.blue-bg{
      background: #DBEDFF;
    }
  }
  .filter-container {
    margin-bottom: 30px;
    background: white;
    border: 1px solid #D1D5DA;
    border-radius: 5px;
    display: flex;
    .filter-left, .filter-middler, .filter-right, .filter-last {
      padding: 15px 16px;
    }
    .filter-left {
      padding-right: 10px;
      width: 290px;
      flex: 1;

    }
    .left-border{
      border-left: 1px solid #E1E4E8;
    }
    .filter-middler {
      border-left: 1px solid #E1E4E8;
      border-right: 1px solid #E1E4E8;
      flex: 1;
    }
    .filter-right {
      border-right: 1px solid #E1E4E8;
      flex: 1;
    }
    .filter-last{
      flex: 2;
    }
    .filter-box-text{
      display: flex;
      margin-bottom: 12px;
      /*justify-content: space-between;*/
      margin-right: 20px;
      span{
        margin-right: 10px;
        font-family: Inter;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 17px;
      }
      span:first-child{
        color: #24292E;
        font-weight: 600;

      }
      .flex{
        span{
          color: #0366D6;
          cursor: pointer;
        }
      }
    }
    .all {
      display: inline-block;
      padding-left: 15px;
      color: #409eff;
      cursor: pointer;
      font-weight: 600;
    }
    .flex-wrap{
      flex-wrap: wrap !important;
    }
    .filter-left-container {
      display: flex;
      align-items: center;
    }
    & > span:first-child {
      font-size: 12px;
      font-weight: bold;
    }


    .input-container {
      max-width: 360px;
    }
    .button-right {
      // position: absolute;
      // right: 0;
      margin-left: 20px;
    }

    .filter-box {
      margin-right: 20px;
      .span-status {
        display: flex;
        align-items: center;
        /deep/ .el-checkbox__label {
          margin-left: 10px;
          padding: 0 10px;
          font-size: 12px;
          border: 1px solid #b08800;
          color: #b08800;
          background: white;
          border-radius: 50px;
          line-height: 20px;
          white-space: nowrap;
        }
      }
      .upload-status {
        display: flex;
        align-items: center;
        /deep/ .el-checkbox__label {
          margin-left: 10px;
          padding: 0 10px;
          font-size: 12px;
          border: 1px solid #0366D6;
          color: #0366D6;
          background: white;
          border-radius: 50px;
          line-height: 20px;
          white-space: nowrap;
        }
      }
    }
    .type-button {
      // margin-right: 20px;
      margin-top:20px;
      ::v-deep .el-radio {
        //margin-right: 20px!important;
        width: 138px;
        .el-radio__label {
          display: inline-block;
          padding: 0px 10px;
          height: auto;
          //line-height: 30px;
          font-size: 12px;
          border-radius: 50px;
          border: 1px solid #E1E4E8;
          color: #24292E;
          background: white;
          font-weight: 500;
          letter-spacing: 0;
          line-height: 18px;
          margin-left:8px ;
        }
      }
      .border-none{
        ::v-deep .el-radio {
          .el-radio__label {
            border: none;
            font-size: 14px;
            /*border-radius: 50px;*/
            border:none;
            color: #24292E;
            background: white;
            font-weight: 600;
            letter-spacing: 0;
            line-height: 18px;
          }
        }
      }
    }
    .status-button {
      // margin-right: 20px;
      /*margin-top:20px;*/
      ::v-deep .el-checkbox-group {
        .el-checkbox {
          .el-checkbox__label {
            span {
              display: inline-block;
              padding: 0px 10px;
              height: auto;
              //line-height: 30px;
              font-size: 12px;
              border-radius: 50px;
              border: 1px solid #E1E4E8;
              color: #24292E;
              background: white!important;
              font-weight: 500;
              letter-spacing: 0;
              line-height: 18px;
            }
          }
          &:first-child {
            .el-checkbox__label {
              span {
                border: 1px solid #735C0F;
                color: #735C0F;
              }
            }
          }
          &:nth-child(2) {
            .el-checkbox__label {
              span {
                border: 1px solid #0366D6;
                color: #0366D6;
              }
            }
          }
          &:nth-child(3) {
            .el-checkbox__label {
              span {
                border: 1px solid #22863A;
                color: #22863A;
              }
            }
          }
        }
      }
    }

    .snooze-filter {
      // margin-right: 20px;
      /*margin-top:20px;*/
      ::v-deep .el-checkbox-group {
        .el-checkbox {
          margin-right: 20px;
          .el-checkbox__label {
            padding: 0;
            span {
              display: flex;
              display: inline-block;
              //padding: 0px 10px;
              height: auto;
              //line-height: 30px;
              font-size: 14px;
              /*border-radius: 50px;*/
              border:none;
              color: #24292E;
              background: white;
              font-weight: 600;
              letter-spacing: 0;
              line-height: 18px;
            }
          }
        }
      }
    }

    .el-checkbox-group {
      display: flex;
      flex-wrap: nowrap;
    }
  }
  .flex-checkout{
    display: flex;
    margin-top: 11px;
    .el-checkbox-group {
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      align-items: flex-start;
    }
    .flex{
      align-items: center;
    }
  }
  .circle {
    display: inline-block;
    margin-right: 5px;
    width: 14px;
    height: 14px;
    min-width: 14px;
    min-height: 14px;
    border-radius: 100%;
    &.orange-light {
      background: #E36209;
    }
    &.yellow-dark {
      background: #DBAB09;
    }
    &.blue {
      background: #0366D6;
    }
    &.green {
      background: #28A745;
    }
    &.red {
      background: #D73A49;
    }
    &.purple {
      background: #6F42C1;
    }
  }

  ::v-deep .tableHeader {
    margin-top: 30px;
    background: #F6F8FA !important;
    height: 45px;
    th {
      background-color:#F6F8FA !important;
      font-family: Inter;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      letter-spacing: -0.15px;
      color: #24292E;
      height: 45px;
      .cell{
        height: 30px;
      }
    }
  }
  .span-status {
    /*display: block;*/
    margin-right: 5px;
    padding: 0 8px;
    //height:  20px;
    //line-height: 20px;
    border-radius: 25px;
    white-space: nowrap;

    height: 18px;
    //font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #24292E;
    &.success {
      color:  rgb(67, 181, 92);
      background: rgb(220, 255, 228);
    }
    &.warning {
      background: rgb(255, 245, 177);
      color: rgb(218, 193, 93);
    }
    &.error {
      background: rgb(215, 58, 73);
      color: white;
    }
    &.warning-plain {
      border: 1px solid #B08800;
      color: #B08800;
    }
    &.unread-uplod {
      border: 1px solid #0366D6;
      color: #0366D6;
    }
    &.type-status{
      border: 1px solid #E1E4E8;
      color: #24292E;
    }
  }
  .status-height{
    height: 18px;
    line-height: 18px;
    padding: 0px 10px;
  }
  .status-two{
    border: 1px solid #0366D6;
    color: #0366D6;
    display: inline-block;
    padding: 0px 8px;
    font-size: 12px;
    border-radius: 50px;
    height: 18px;
    line-height: 18px;
    //font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
  }
  .status-one{
    border: 1px solid #735C0F;
    color: #735C0F;
    display: inline-block;
    padding: 0px 8px;
    font-size: 12px;
    border-radius: 50px;
    height: 18px;
    line-height: 18px;
    //font-family: Inter;
    font-style: normal;
    font-weight: 600;
  }
  .status-three
  {
    border: 1px solid #22863A;
    color: #22863A;
    display: inline-block;
    padding: 0px 8px;
    font-size: 12px;
    border-radius: 50px;
    height: 18px;
    line-height: 18px;
    //font-family: Inter;
    font-style: normal;
    font-weight: 600;
  }
  .span-status-stts{
    //font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    /* identical to box height, or 150% */
    display: inline-block;
    color: #FFFFFF;
    padding: 0px 8px;
    height: 18px;

    //background: #E36209;
    border-radius: 100px;
    &.orange-light {
      background: #E36209;
    }
    &.yellow-dark {
      background: #DBAB09;
    }
    &.blue {
      background: #0366D6;
    }
    &.green {
      background: #28A745;
    }
    &.red {
      background: #D73A49;
    }
    &.purple {
      background: #6F42C1;
    }

  }
  .flex-aglin{
    display: flex;
    flex-direction: column;
    justify-content:space-between ;
    p{
      height: 24px;
    }
    p:first-child{
      color: #24292E;
      font-size: 14px;
      font-weight: 600;
    }
  }
  .liter-text{
    color: #6A737D;
    font-family: Inter;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 18px;
    height: 18px;
  }

  .text-right{
    position: absolute;
    z-index: 100;
    right: 1px;
    margin-top: 6px;
    //margin-right: 15px;
    height: 40px;
    width: 90%;
    background-color:#F6F8FA !important;
  }
}
.el-table{
  border-radius: 4px;
  border:1px solid #D1D5DA;
  ::v-deep .flex-algin{
    //display: flex;
    //flex-direction: column;
    //justify-content:space-between ;
    p,span{
      height: 24px;
    }
    .flex-circle{
      height: 24px;
      align-items: center;
      span{
        color: #24292E;
        font-size: 14px;
        font-weight: 600;
      }
    }
    p:first-child{
      color: #24292E;
      font-size: 14px;
      font-weight: 600;
      span{
        font-weight: 600;
      }
    }
  }
  .liter-time{
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    color: #24292E;
  }
  .liter-text{
    color: #6A737D;
    font-family: Inter;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 15px;
  }
  .text-span{
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: #24292E;
  }
  ::v-deep .el-table-column--selection{
    .cell{
      padding-left: 15px!important;
    }
  }
  ::v-deep td{
    padding: 10px 0!important;
    vertical-align: top;
  }
  ::v-deep .el-checkbox:last-of-type{
    margin-top: 4px;
  }
}
::v-deep .el-date-editor{
  width: 200px!important;
}
.showLick{
  color:  #000;
  text-decoration: none;
  &:hover{
    color:  #0366D6;
  }
}
</style>
